import React from "react";
import "./Socials.scss";

const FacebookLogo = () => {
  return (
    <svg
      width="11"
      height="20"
      viewBox="0 0 11 20"
      fill="none"
      className="social-logo"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_0_449"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="11"
        height="19">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.49081 18.5456V10.4135H0.76709V7.18195H3.49081V4.63579C3.49081 1.86945 5.18115 0.36377 7.64919 0.36377C8.83172 0.36377 9.84735 0.452548 10.1421 0.49161V3.38224H8.43044C7.08811 3.38224 6.82888 4.02144 6.82888 4.95539V7.18195H9.858L9.44252 10.4135H6.82888V18.5456"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_0_449)">
        <rect
          x="-5.45459"
          y="-1.45459"
          width="21.8182"
          height="21.8182"
          fill="#F7FAFF"
        />
      </g>
    </svg>
  );
};

export default FacebookLogo;
